module.exports = __webpack_public_path__ + "img/line-layer.72bb7ad8.svg";